import * as tslib_1 from "tslib";
import * as React from 'react';
import { observable, action } from 'mobx';
import { TaskBoard } from './pages/tasks/TaskBoard';
import TimeOverview from './pages/timeoverview/TimeOverview';
import DayOffsPage from './pages/dayoffs/DayOffsPage';
import { Statistics } from './pages/statistics/Statistics';
import { Summary } from './pages/statistics/Summary';
import { Messages } from './pages/messages/Messages';
import MessageBadge from './components/MessageBadge';
import BoardyMemoryGame from './components/BoardyMemoryGame';
import NfcTaskPage from './pages/nfctask/NfcTaskPage';
import { FontIcon, IconButton } from 'material-ui';
import SearchPage from './pages/search/SearchPage';
var RouteDefinition = /** @class */ (function () {
    function RouteDefinition(options) {
        Object.assign(this, options);
    }
    tslib_1.__decorate([
        observable
    ], RouteDefinition.prototype, "isActive", void 0);
    return RouteDefinition;
}());
var RouteCollection = /** @class */ (function () {
    function RouteCollection(routes) {
        this.routes = routes;
    }
    RouteCollection.prototype.getEnabledRoutes = function (userStore, projectStore) {
        return this.routes.filter(function (i) {
            return i.visible(userStore) &&
                (i.enabled ? i.enabled(projectStore.configuration) : true);
        });
    };
    RouteCollection.prototype.getVisibleRoutes = function (userStore, projectStore) {
        return this.routes.filter(function (i) {
            return i.navigation &&
                i.visible(userStore) &&
                (i.enabled ? i.enabled(projectStore.configuration) : true);
        });
    };
    RouteCollection.prototype.setActive = function (route) {
        history.pushState(null, 'Boardy', route.path);
        for (var _i = 0, _a = this.routes; _i < _a.length; _i++) {
            var item = _a[_i];
            item.isActive = item.path === route.path;
        }
    };
    tslib_1.__decorate([
        action.bound
    ], RouteCollection.prototype, "setActive", null);
    return RouteCollection;
}());
var taskPageComponent = window.location.href.includes('nfc')
    ? NfcTaskPage
    : TaskBoard;
var routeCollection = new RouteCollection([
    new RouteDefinition({
        navigation: false,
        exact: true,
        title: 'MemoryGame',
        path: '/memory-game',
        component: BoardyMemoryGame,
        visible: function (_) { return true; },
        isActive: true
    }),
    new RouteDefinition({
        navigation: true,
        exact: true,
        title: (React.createElement(IconButton, { key: "search", style: { top: '7px' } },
            React.createElement(FontIcon, { color: "white", className: "material-icons" }, "search"))),
        path: '/search',
        component: SearchPage,
        visible: function (_) { return true; },
        enabled: function (config) { return config && config.isTaskSearchEnabled; },
        isActive: true
    }),
    new RouteDefinition({
        navigation: true,
        exact: true,
        title: 'Feladatok',
        path: '/',
        component: taskPageComponent,
        visible: function (_) { return true; },
        isActive: true
    }),
    new RouteDefinition({
        navigation: true,
        exact: false,
        title: 'Idők',
        path: '/times',
        component: TimeOverview,
        visible: function (_) { return true; },
        isActive: false
    }),
    new RouteDefinition({
        navigation: true,
        exact: false,
        title: 'Munkarendek',
        path: '/dayoffs',
        component: DayOffsPage,
        visible: function (_) { return true; },
        isActive: false
    }),
    new RouteDefinition({
        navigation: true,
        exact: false,
        title: 'Statisztika',
        path: '/statistics',
        component: Statistics,
        visible: function (store) { return !store.loggedInUserIsAdmin; },
        isActive: false
    }),
    new RouteDefinition({
        navigation: true,
        exact: false,
        title: 'Összesítő',
        path: '/summary',
        component: Summary,
        visible: function (store) { return store.loggedInUserIsAdmin; },
        isActive: false
    }),
    new RouteDefinition({
        navigation: true,
        exact: false,
        isActive: false,
        title: 'Üzenetek',
        path: '/messages',
        component: Messages,
        visible: function (_) { return true; },
        element: function (store) { return store.messages && store.messages.unreadedMessages > 0
            ? React.createElement(MessageBadge, { key: "badge", count: store.messages.unreadedMessages })
            : null; }
    }),
    new RouteDefinition({
        navigation: false,
        exact: false,
        title: 'Feladatok',
        path: '/nfc-tasks',
        component: NfcTaskPage,
        visible: function (_) { return true; },
        isActive: true
    })
]);
export { routeCollection, RouteDefinition };



//////////////////
// WEBPACK FOOTER
// ./src/routes.tsx
// module id = 273
// module chunks = 0